// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__luNc0","raceDate":"Title_raceDate__1DInV","raceFullName":"Title_raceFullName__bJAMX","chartTitle":"Title_chartTitle__3fxKX","mssLogo":"Title_mssLogo__2qGgL"};